module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "microphoneSetting2 flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "microphoneSettingDialog2 flexcenter"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "microphoneSettingDialog2Inner"
  }, [_c('h3', [_vm._v("マイク設定")]), _vm._v(" "), _c('div', {
    staticClass: "modal-inner"
  }, [(_vm.viewState === 'init') ? _c('div', {
    staticClass: "inittext"
  }, [(_vm.isFlash) ? _c('div', [_c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("①")]), _vm._v("以下の手順に従って、本サイトのマイク使用が許可されていることを確認します。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "anchor"
  }, [_c('a', {
    staticClass: "mic-anchor",
    attrs: {
      "href": "http://www.sourcenext.com/support/qa/?faq=RS-08885",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sourcenext.com/support/qa/?faq=RS-08885")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("②")]), _vm._v("図のとおりにヘッドセットを装着します。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("③")]), _vm._v("[続行]をクリックして開始します。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("④")]), _vm._v("音が聞こえたら、いつも通りの声で「1、2、3、4、5」と言ってください。")])]) : _c('div', [_c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("①")]), _vm._v("図のとおりにヘッドセットを装着します。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("②")]), _vm._v("[続行]をクリックして開始します。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num"
  }, [_vm._v("③")]), _vm._v("音が聞こえたら、いつも通りの声で「1、2、3、4、5」と言ってください。")])])]) : (_vm.viewState === 'setting') ? _c('div', {
    staticClass: "setting"
  }, [_c('p', [_vm._v("「1、2、3、4、5」と話します。")]), _vm._v(" "), _c('div', {
    staticClass: "indicator flexbetween"
  }, _vm._l((11), function(n) {
    return _c('div', [(11 == n) ? _c('span', {
      staticClass: "mic-icon"
    }, [_c('img', {
      attrs: {
        "src": require("../../static/images/icon/setting/mic_icon.png")
      }
    })]) : (_vm.volumeIndicator >= n) ? _c('span', {
      staticClass: "on"
    }) : _c('span', {
      staticClass: "off"
    })])
  }), 0)]) : (_vm.viewState === 'success') ? _c('div', {
    staticClass: "success"
  }, [_c('p', [_vm._v("マイクが正しく設定されました。")]), _vm._v(" "), _c('p', [_vm._v("設定を保存するには、[続行]をクリックします。")])]) : (_vm.viewState === 'fail') ? _c('div', {
    staticClass: "failed"
  }, [_c('p', [_vm._v("マイクを正しく設定できていません。")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "common"
  }, [_c('div', {
    staticClass: "num align-center lbold font28"
  }, [_c('span', [_vm._v("1")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v("2")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v("3")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v("4")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "headphone align-center font12"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/icon/setting/microphone.png")
    }
  })]), _vm._v(" "), (_vm.platform.name == 'Chrome') ? _c('p', {
    staticClass: "current-mic align-center font12"
  }, [_vm._v("現在選択されているマイク: " + _vm._s(_vm.microphone.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "buttons flexcenter"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.locked
    },
    on: {
      "click": _vm.doCancel
    }
  }, [_vm._v(_vm._s(_vm.buttonCancel))]), _vm._v(" "), _c('button', {
    staticClass: "continue",
    attrs: {
      "type": "button",
      "disabled": _vm.locked
    },
    on: {
      "click": _vm.doContinue
    }
  }, [_vm._v(_vm._s(_vm.buttonContinue))])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-33f49f0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-33f49f0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MicrophoneSetting.vue
// module id = 616
// module chunks = 1